document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  document.querySelectorAll('[data-menu-open]').forEach((button) => button.addEventListener('click', () => body.classList.add('menu-open')));
  document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', () => body.classList.remove('menu-open')));
  document.querySelectorAll('[data-date-open]').forEach((button) => button.addEventListener('click', () => {
    const dialog = document.querySelector('#AvacardoDateBook');
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
  }));
  const form = document.querySelector('#ImportantDateForm');
  if (form) form.addEventListener('submit', () => {
    const data = Object.fromEntries(new FormData(form).entries());
    const saved = JSON.parse(localStorage.getItem('avacardoImportantDates') || '[]');
    saved.push({ person: data['contact[Person]'], occasion: data['contact[Occasion]'], date: data['contact[Date]'] });
    localStorage.setItem('avacardoImportantDates', JSON.stringify(saved.slice(-30)));
  });
});
